var REACT_ELEMENT_TYPE;function _jsx(type, props, key, children) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var defaultProps = type && type.defaultProps,childrenLength = arguments.length - 3;if (props || 0 === childrenLength || (props = { children: void 0 }), 1 === childrenLength) props.children = children;else if (childrenLength > 1) {for (var childArray = new Array(childrenLength), i = 0; i < childrenLength; i++) childArray[i] = arguments[i + 3];props.children = childArray;}if (props && defaultProps) for (var propName in defaultProps) void 0 === props[propName] && (props[propName] = defaultProps[propName]);else props || (props = defaultProps || {});return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: void 0 === key ? null : "" + key, ref: null, props: props, _owner: null };}import React from 'react';







const PreserveIcon = ({ width = '24', height = '24', color }) => /*#__PURE__*/
_jsx("svg", {
  width: width,
  height: height,
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg" }, void 0, /*#__PURE__*/

_jsx("path", {
  d: "M12 15C13.6569 15 15 13.6569 15 12C15 10.3431 13.6569 9 12 9C10.3431 9 9 10.3431 9 12C9 13.6569 10.3431 15 12 15Z",
  stroke: color || 'currentColor',
  strokeWidth: "2",
  strokeLinecap: "round",
  strokeLinejoin: "round" }
), /*#__PURE__*/
_jsx("path", {
  d: "M3 7V5C3 4.46957 3.21071 3.96086 3.58579 3.58579C3.96086 3.21071 4.46957 3 5 3H7",
  stroke: color || 'currentColor',
  strokeWidth: "2",
  strokeLinecap: "round",
  strokeLinejoin: "round" }
), /*#__PURE__*/
_jsx("path", {
  d: "M17 3H19C19.5304 3 20.0391 3.21071 20.4142 3.58579C20.7893 3.96086 21 4.46957 21 5V7",
  stroke: color || 'currentColor',
  strokeWidth: "2",
  strokeLinecap: "round",
  strokeLinejoin: "round" }
), /*#__PURE__*/
_jsx("path", {
  d: "M21 17V19C21 19.5304 20.7893 20.0391 20.4142 20.4142C20.0391 20.7893 19.5304 21 19 21H17",
  stroke: color || 'currentColor',
  strokeWidth: "2",
  strokeLinecap: "round",
  strokeLinejoin: "round" }
), /*#__PURE__*/
_jsx("path", {
  d: "M7 21H5C4.46957 21 3.96086 20.7893 3.58579 20.4142C3.21071 20.0391 3 19.5304 3 19V17",
  stroke: color || 'currentColor',
  strokeWidth: "2",
  strokeLinecap: "round",
  strokeLinejoin: "round" }
)
);


export { PreserveIcon };